import React, {Component} from 'react';

import FormValidator from './form-validator';

import UsersApi from '../../../lib/users/users-api';

import RegistrationLayout from "./registration-layout";
import RegistrationFormContainer from './registration-form-container';
import WelcomeScreen from './screen-welcome';

import LargeButton from '../../../components/buttons/large-button';
import Checkbox from '../../../components/checkbox';
import PrevButton from '../../../components/buttons-navigation/button-previous';

class ConfirmationDetailsScreen extends Component {

    constructor(props) {
        super(props);
        this.validator = new FormValidator([
            {
                field: 'details_confirmation',
                method: this.isTrue,
                validWhen: true,
                message: 'Please confirm your details'
            },
            {
                field: 'details_agree_terms',
                method: this.isTrue,
                validWhen: true,
                message: 'You must accept the Terms of Use and the Privacy Policy to register an account'
            }
        ]);
        this.state = {
            ...props,
            validation: this.validator.valid(),
            errors: [],
            company_types_label: ''
        }
        this.submitted = false;
    }

    isTrue = (confirmation) => ('true' === confirmation)

    onCheckboxDetailsChange({value}) {

        if (this.props.values.details_confirmation == value) {

            return this.props.onChange('details_confirmation', false);
        }
        this.props.onChange('details_confirmation', value);
    }

    onCheckboxTermsChange({value}) {

        if (this.props.values.details_agree_terms == value) {

            return this.props.onChange('details_agree_terms', false);
        }
        this.props.onChange('details_agree_terms', value);

    }

    onBackClick() {
        this.props.onBack();
    }

    onSubmit() {
        const validation = this.validator.validate({...this.props.values});
        this.setState({validation});
        this.submitted = true;
        if (validation.isValid) {

            UsersApi.register(this.formatParams(), errors => {
                this.setState({errors : _.map(errors, (error) => {
                            return error[0];
                    })})

            }).then(response => {
               this.props.onComplete(this.props.values.email, this.props.values.password);

            })
        }
    }

    formatParams() {
        const {values} = this.props;

        return {
            name : `${values.first_name} ${values.last_name}`,
            first_name: values.first_name,
            last_name: values.last_name,
            email : values.email,
            password: values.password,
            password_confirmation: values.password_confirmation,
            company_industry_id:  values.company_industry_id,
            company : {
                name: values.company_name
            },
            company_profile : {
                number_of_employees_range : values.company_employees,
                company_number : values.company_number,
                company_number_type : values.company_number_type,
                company_type : values.company_type
            },
            invites : values.team_add.map(item => {
                return {
                    email : item.team_email,
                    role_ids : [item.team_role]
                }
            })
        }
    }
    componentDidMount() {
        this.handleCompanyNumberLabel();
    }

    handleCompanyNumberLabel() {
        if (this.props.values.company_type === 'Limited Company') {
            this.setState({company_types_label: 'Company registration number'});
        }
        if (this.props.values.company_type === 'Sole Trader') {
            this.setState({company_types_label: 'UTR Number'});
        }
        if (this.props.values.company_type === 'Charity') {
            this.setState({company_types_label: 'Charity Number'});
        }
    }

    getIndustryById(id) {
        const industries = this.props.industries || [];

        const index = _.findIndex(industries, i => {
            return i.id === id;
        })

        if (index !== -1) {
            return industries[index];
        }

        return {};
    }

    render() {
        const validation = this.state.validation
        const errors = this.state.errors
        const label = this.state.company_types_label
        const {values} = this.props;

        console.log(values, 'confirmation values');
        return (
            <RegistrationLayout
                left={<WelcomeScreen img={"/assets/grants-card.svg"} label={"Enterprising Barnsley Grants Portal"} title={"Apply for available grants with ease"} description={"Simply log in, browse, apply, and manage in one place - giving you the opportunity to support your business here in Barnsley"}/>}
                right={<RegistrationFormContainer heading='Register your account' text="Already have an account?"
                                                  linkText='Sign In' linkHref='/login'>
                    <div className="registration-form__container gap">
                        <div className='registration-form__heading-conteiner utils__row'>
                            <h2>Confirm your details</h2>
                        </div>
                        <div className='registration-form__change-button'>
                            <PrevButton onClick={this.onBackClick.bind(this)}>Make a change</PrevButton>
                        </div>
                        <div className='confirmation__container'>
                            <div className='confirmation__row'>
                                <p>Your name</p>
                                <p>{values.first_name} {values.last_name}</p>
                            </div>
                            <div className='confirmation__row'>
                                <p>Your email address</p>
                                <p>{values.email}</p>
                            </div>
                            <div className='confirmation__row'>
                                <p>Your registered business name</p>
                                <p>{values.company_name}</p>
                            </div>
                            <div className='confirmation__row'>
                                <p>What type of business are you?</p>
                                <p>{values.company_type}</p>
                            </div>
                            {values.company_number.length > 0 &&
                            <div className='confirmation__row'>
                                <p>{label}</p>
                                <p>{values.company_number}</p>
                            </div>
                            }
                            <div className='confirmation__row'>
                                <p>Industry</p>
                                <p>{this.getIndustryById(values.company_industry_id).name}</p>
                            </div>
                            <div className='confirmation__row'>
                                <p>Number of Employees</p>
                                <p>{values.company_employees}</p>
                            </div>
                            <div className='confirmation__row'>
                                <p>Invites to be sent</p>
                                <p>{values.team_add.length}</p>
                            </div>
                        </div>
                        <div className='confirmation__checkboxes  utils__gap--20'>
                            <Checkbox text='I confirm that all details are correct'
                                      error={validation.details_confirmation.message}
                                      onChange={this.onCheckboxDetailsChange.bind(this)}
                                      checked={values.details_confirmation == true}/>

                            <Checkbox text={`<span>I agree to the <a
                                        href="https://www.enterprisingbarnsley.co.uk/terms-of-use/"
                                        target="_blank">Terms of Use</a> and <a
                                        href="https://www.enterprisingbarnsley.co.uk/privacy-policy/" target="_blank">Privacy Policy</a></span>`}
                                      error={validation.details_agree_terms.message}
                                      onChange={this.onCheckboxTermsChange.bind(this)}
                                      checked={values.details_agree_terms == true}/>
                        </div>
                        <div className='registration-form__container'>
                            <LargeButton onClick={this.onSubmit.bind(this)}
                                     className="button--register">Register</LargeButton>
                        {errors.length > 0 &&
                            <div className='input-outer__errors'>{errors.map((errors, index) => {
                                return(
                                    <p key={index}>{errors}</p>
                                );
                            })}</div>}
                        </div>

                    </div>
                </RegistrationFormContainer>}/>
        );
    }
}

export default ConfirmationDetailsScreen;
